<template>
    <v-card flat>
        <v-card-title class="subheader py-0">
            <v-icon small class="mr-1" color="teal">group</v-icon>
            失信项目列表
            <v-spacer/>
            <v-btn flat round color="primary" dark
                   :disabled="!funcIds.includes('c_integrity_proj')"
                   @click.native.stop="
             () => {
                  addDbid = infoBasic? infoBasic.dbid: null;
                  deptName = infoBasic.department.name;
                  deptId = infoBasic.department.deptId;
                  uName = infoBasic.name;
                  add = true;
                }">
                <v-icon>add</v-icon>
                新增项目
            </v-btn>
        </v-card-title>

        <v-divider color="teal"/>

        <v-card-text class="pt-0">
            <v-data-table
                    :headers="headers"
                    :items="items"
                    hide-actions
                    class="elevation-0 dense"
                    no-data-text="没有数据。"
            >
                <template slot="items" slot-scope="props">
                    <td>{{props.index + 1}}</td>
                    <td class="text-xs-center">{{props.item.projName}}</td>
                    <td class="text-xs-center">{{props.item.number}}</td>
                    <td class="text-xs-center">{{props.item.entryDate}}</td>
                    <td class="text-xs-center">{{props.item.startDate}}</td>
                    <td class="text-xs-center">{{props.item.finishDate}}</td>
                    <td class="text-xs-center">{{props.item.status}}</td>
                    <td class="text-xs-center">{{props.item.deptName}}</td>
                    <td class="text-xs-center">{{props.item.adminDept}}</td>
                    <td class="text-xs-center">{{props.item.contractAmounts}}</td>
                    <td class="justify-center layout px-0">
                        <v-tooltip top>
                            <v-btn icon class="mx-0" slot="activator"
                                   :disabled="!funcIds.includes('d_integrity_proj')"
                                   @click="
                                   () => {
                                      deleDbid = props.item.dbid;
                                      deleMsg = `${props.item.projName}`;
                                      dele = true;
                                     }">
                                <v-icon color="pink">delete_forever</v-icon>
                            </v-btn>
                            <span>删除</span>
                        </v-tooltip>
                    </td>
                </template>
            </v-data-table>
        </v-card-text>
        <x-proj-add
                v-model="add"
                :dbid="addDbid"
                :deptName="deptName"
                :deptId="deptId"
                :uName="uName"
                v-on:ok="onAddOk"
        />

        <x-delete
                v-model="dele"
                :message="deleMsg"
                :uri="uri"
                :dbid="deleDbid"
                v-on:ok="onDeleOk"
        />

    </v-card>
</template>
<script>
    import {mapGetters} from 'vuex'
    import XProjAdd from './projAdd'

    import XDelete from '@/components/global/Delete'

    const baseURI = '/api/integrity/integrity';
    export default {
        components: {XProjAdd, XDelete},

        props: {
            infoBasic: Object
        },

        data: () => ({
            uri: baseURI+'/proj',
            headers: [
                {text: '#', value: 'dbid', sortable: false,  width: 20},
                {text: '项目名称', value: 'projName', sortable: false, width: 200},
                {text: '项目编号', value: 'number', sortable: false, width: 20},
                {text: '立项时间', value: 'entryDate', sortable: false, width: 20},
                {text: '项目开始时间', value: 'startDate', sortable: false, width: 20},
                {text: '项目截止时间', value: 'finishDate', sortable: false, width: 20},
                {text: '项目状态', value: 'status', sortable: false, width: 40},
                {text: '项目所属部门', value: 'deptName', sortable: false, width: 120},
                {text: '项目主管部门', value: 'adminDept', sortable: false, width: 120},
                {text: '合同金额(元)', value: 'contractAmounts', sortable: false, width: 60},
                {text: '操作', value: 'dbid', sortable: false, align: 'center', width: 120}

            ],

            items: [],

            add: false,
            addDbid: null,
            uName: null,
            deptName: null,
            deptId: null,

            loading: false,

            dele: false,
            deleDbid: null,
            deleMsg: null,

            /**
             * 验证规则
             */
            rules: {
            }
        }),

        beforeMount() {

        },

        watch: {
            infoBasic(p) {
                const dbid = p.dbid;
                this.axios
                    .get(`${baseURI}/proj/${dbid}`)
                    .then(rsp => {this.items = rsp.data.items})
            }
        },

        computed: {
            ...mapGetters(['funcIds'])
        },
        methods: {
            getDefault() {
                return {
                    dbid: this.infoBasic.dbid,
                    serialNum: this.items.length + 1,
                    property: !this.items.length ? '新增' : '追加',
                }
            },
            onAddOk(its) {
                window.console.log(its);
                if (its) {
                    this.items.unshift(...its);
                }
            },
            onEditOk(item) {
                if (item) {
                    if (!this.editDbid) {
                        this.items.unshift(item);
                    } else {
                        const editIdx = this.items.findIndex(v => v.dbid === item.dbid);
                        this.items[editIdx] = window.xutil.clone(item);
                    }
                }
            },
            onDeleOk(item) {
                if (item) {
                    const deleIdx = this.items.findIndex(v => v.dbid === item.dbid);
                    this.items.splice(deleIdx, 1);
                }
            }
        }
    }
</script>
